module.exports = __webpack_public_path__ + "static/img/level-card-banner2.dc389d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/level-card-banner2.png
// module id = 9cw7
// module chunks = 1